module.exports = __webpack_public_path__ + "background-phablet.d651399d46f2ce596c92.png";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/images/background-phablet.png
// module id = ../../../../../src/assets/images/background-phablet.png
// module chunks = 2